import React from 'react';
import { useDebriefDispatch, useMapSettings } from 'ff/debrief/hooks';
import MenuItem from '@mui/material/MenuItem';
import Divider from '@mui/material/Divider';
import { setTheme, toggleMapSetting } from 'ff/debrief/features/MapSlice';
import { AirspaceSettings } from 'ff/debrief/components/map/settings/sections/AirspaceSettings';
import {
    SettingCheckbox,
    SettingHeader,
    SettingLabel,
} from 'ff/debrief/components/map/settings/shared';
import { CulturalElementSettings } from 'ff/debrief/components/map/settings/sections/CulturalSettings';
import { AirportMapSettings } from 'ff/debrief/components/map/settings/sections/AirportSettings';
import Switch from '@mui/material/Switch';
import styled from 'styled-components';
import { AirwaySettings } from 'ff/debrief/components/map/settings/sections/AirwaySettings';
import { SettingName } from 'ff/debrief/models';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

const AlignRight = styled.div`
    position: absolute;
    right: 0;
    padding: 0 6px;
`;
const MapSettings = () => {
    const dispatch = useDebriefDispatch();
    const { currentSettings } = useMapSettings();

    const setSetting = (settingName: SettingName, value: boolean) => {
        dispatch(toggleMapSetting({ settingName: settingName, value: value }));
    };

    return (
        <>
            <SettingHeader variant="h1">ForeFlight Map</SettingHeader>
            <MenuItem>
                <SettingLabel htmlFor="mapTheme">Map Theme</SettingLabel>
                <AlignRight>
                    <Stack direction="row" spacing={1} alignItems="center">
                        <Typography>Light</Typography>
                        <Switch
                            checked={currentSettings?.theme === 'dark'}
                            onChange={(
                                e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                                const theme = e.target.checked
                                    ? 'dark'
                                    : 'light';
                                dispatch(setTheme(theme));
                            }}
                        />
                        <Typography>Dark</Typography>
                    </Stack>
                </AlignRight>
            </MenuItem>
            <Divider />
            <MenuItem>
                <SettingCheckbox
                    id="placeLabels"
                    displayName="Place Labels"
                    checked={currentSettings?.placeLabels}
                    onChange={e => setSetting('placeLabels', e.target.checked)}
                />
            </MenuItem>
            <CulturalElementSettings />
            <AirportMapSettings />
            <AirspaceSettings />
            <AirwaySettings />
        </>
    );
};

export default MapSettings;
